import { getXprops } from 'app/helpers/getXprops';
import { ConektaSource } from 'app/sdk/embedded/EmbeddedConfig';

export const redirectToHostedPaymentUrl = async (urlRedirect: string, redirectionTime: number) => {
  const xprops = getXprops();
  const { conektaSource } = xprops;
  const milliseconds = redirectionTime
    ? redirectionTime * 1000
    : Number(process.env.HOSTED_PAYMENT_URL_MILLISECONDS_TO_REDIRECT || 0);
  if (!urlRedirect) return;

  const redirect = () => {
    setTimeout(() => (window.top.location.href = urlRedirect), milliseconds);
  };

  if (conektaSource !== ConektaSource.EMBEDDED) {
    if (xprops && xprops.preRedirect) {
      const haveToRedirect: boolean = await xprops.preRedirect(urlRedirect);
      if (haveToRedirect) {
        redirect();
      }
    } else {
      redirect();
    }
  }
};
